import { Injectable } from '@angular/core';

import { GenericAPIResource, GenericElementResource } from "./generic-api.model";
import {  ResourceSerializer as IResourceSerializer } from "./rest-resource.interface";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/internal/Observable';
import { RestResourceService } from './rest-resource.service';


@Injectable({
  providedIn: 'root'
})
export class PhotographerNetworkService extends RestResourceService  {
  constructor(private http: HttpClient) {
    super(http, '/MembersPhotoApi/api/Photographer', new PhotographerNetworkSerializer());
  }
  public getPhotographerNetwork(): Observable<PhotographerNetwork[]> {
    let requestUrl = 'GetPhotographerNetwork';
    return this.Get<PhotographerNetwork>(requestUrl,"");
  }
}

export class PhotographerNetwork extends GenericAPIResource {

  constructor(copyObj: PhotographerNetwork = null) {
    super();
    if (copyObj == null) {
      return;
    }
    this.Username = copyObj.Username;
    this.FName = copyObj.FName;
    this.LName = copyObj.LName;
    this.Phone = copyObj.Phone;
    this.Cellphone = copyObj.Cellphone;
    this.Email = copyObj.Email;
    this.Website = copyObj.Website;
    this.City = copyObj.City;
    this.HasLogo = copyObj.HasLogo;
    this.LogoUrl = copyObj.LogoUrl;
  }
  Username: string;
  FName: string;
  LName: string;
  Phone: string;
  Cellphone: string;
  Email: string;
  Website: string;
  City: string;
  HasLogo: boolean;
  LogoUrl: string;
}
export class PhotographerNetworkSerializer implements IResourceSerializer {
  fromJson(json) {
    let obj = new PhotographerNetwork(json);
    return obj;
  }

  toJson(resource) { return resource; }
}
